import React from 'react'
import LineUpAllHome from './LineUpAllHome'
import LineUpAllAway from './LineUpAllAway'

export default function KadroAll() {
  return (
    <div className='KadroAllContainer'>
        <LineUpAllHome/>
        <LineUpAllAway/>
    </div>
  )
}
